const storageKeys = {
  locale: 'locale',
  token: 'token',
};

export default storageKeys;
